import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'

import {
  setRecoveryRequestId,
  setRecoveryStep,
  setRecoveryMaskedData as setMaskedData,
} from '../../../modules/recovery/actions/creators'

import MainView from '../components/MainView/MainView'

// import { setFirebaseMessagingToken } from '../../../modules/auth/actions/creators'
// import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import { doRequestAccountRecovery } from '../../../controllers/AccountRecovery'
import { doSubscribeToFirebaseMessaging } from '../../../controllers/Firebase'

const mapStateToProps = reduxState => {
  const { recovery, auth } = reduxState
  const { firebaseMessagingToken } = auth
  const { recoveryStep, recoveryRequestId } = recovery

  return {
    recoveryRequestId,
    recoveryStep,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doRequestAccountRecovery,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setMaskedData,
      setRecoveryRequestId,
      setRecoveryStep,
      replace,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
